import { LOGIN_SUCCESS, LOGOUT } from '../types/types';
import { queryClient } from '../../config/queryClient';

export const LoginAuthAction = (response: any) => {
	return async (dispatch: any) => {
		dispatch({
			type: LOGIN_SUCCESS,
			payload: response
		});
	};
};

export const LogoutAction = () => {
	return async (dispatch: any) => {
		dispatch({ type: LOGOUT });
		queryClient.clear();
		const { persistor } = await import('../store');
		persistor.purge();
	};
};
